import Referee from './components/Referee/Referee';
import './App.css';

function App() {
  return (
    <div id="app">
      <Referee />
    </div>
  );
}

export default App;
